import { render, staticRenderFns } from "./dragButton.vue?vue&type=template&id=006cf468"
import script from "./dragButton.vue?vue&type=script&lang=js"
export * from "./dragButton.vue?vue&type=script&lang=js"
import style0 from "./dragButton.vue?vue&type=style&index=0&id=006cf468&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports